import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../environment/environment';
import { Observable } from 'rxjs';
import { CheckProgressiviDto, Delibera, DeliberaListDto, IscrittiDeliberaChiusaDto, TipoDelibera } from '../model/delibere-data';
import { SearchFilters } from '../model/filters-data';

@Injectable({
  providedIn: 'root'
})
export class DeliberaService {

  private _http = inject(HttpClient);
  private delibera_api: string = `${environment.baseUrl}/delibere`;
  private log_protocollo_api: string = `${environment.baseUrl}/contatori-protocollo`;

  getTipiDelibera(): Observable<TipoDelibera[]>{
    return this._http.get<TipoDelibera[]>(this.delibera_api + `/tipi_delibera`);
  }

  getDeliberaById(id: number): Observable<Delibera>{
    return this._http.get<Delibera>(this.delibera_api + `/${id}`);
  }

  getIscrittiByDeliberaId(id: number, SearchFilters: SearchFilters): Observable<IscrittiDeliberaChiusaDto>{
    return this._http.post<IscrittiDeliberaChiusaDto>(this.delibera_api + `/iscritti_delibera_chiusa/${id}`, SearchFilters);
  }

  listaDelibere(deliberaFiltriDto: SearchFilters): Observable<DeliberaListDto>{
    return this._http.post<DeliberaListDto>(this.delibera_api, deliberaFiltriDto);
  }

  ultimoNumeroDelibera(): Observable<number>{
    return this._http.get<number>(this.delibera_api + `/ultimo_numero_delibera`);
  }

  approvaDeliberaCorrente(idDelibera: number, dataFinalizzazione: string): Observable<boolean>{
    const data = {
      dataFinalizzazione: dataFinalizzazione
    }
    return this._http.put<boolean>(this.delibera_api + `/approva_delibera/${idDelibera}`, data);
  }

  stampaDeliberaCorrente(idDelibera: number): Observable<Delibera>{
    return this._http.put<Delibera>(this.delibera_api + `/stampa_delibera/${idDelibera}`, {});
  }

  modificaDeliberaCorrente(idDelibera: number, operazioneProgressivo: string): Observable<Delibera>{
    return this._http.put<Delibera>(this.delibera_api + `/abilita_modifica_delibera_corrente/${idDelibera}`, operazioneProgressivo, { headers: { 'Content-Type': 'application/json' }});
  }

  inserisciIscrittoInDelibera(idIscritto: number, idDelibera: number): Observable<boolean>{
    return this._http.put<boolean>(this.delibera_api + `/inserisci_iscritto/${idIscritto}`, idDelibera);
  }

  rimuoviIscrittoDaDelibera(idIscritto: number, idDelibera: number): Observable<boolean>{
    return this._http.put<boolean>(this.delibera_api + `/rimuovi_iscritto/${idIscritto}`, idDelibera);
  }

  inserimentoMassivoInDelibera(idIscritti: number[], idDelibera: number): Observable<boolean>{
    return this._http.put<boolean>(this.delibera_api + `/inserimento_massivo/${idDelibera}`, idIscritti);
  }

  svuotaDelibera(idIscritti: number[], idDelibera: number): Observable<boolean>{
    return this._http.put<boolean>(this.delibera_api + `/svuota_delibera/${idDelibera}`, idIscritti);
  }

  checkCompilaBozza(idDelibera: number): Observable<boolean>{
    return this._http.get<boolean>(this.delibera_api + `/check_compila/${idDelibera}`);
  }

  generaDelibera(numeroDelibera: number, tipoCodice: string, dataDelibera: string): Observable<Delibera>{
    const data = {
      tipoCodice: tipoCodice,
      dataDelibera: dataDelibera,
      numeroDelibera: numeroDelibera
    }
    return this._http.post<Delibera>(this.delibera_api + `/genera_nuova_delibera`, data);
  }

  cancellaDelibera(idDelibera: number, operazioneProgressivo: string): Observable<boolean>{
    return this._http.delete<boolean>(this.delibera_api + `/elimina_delibera/${idDelibera}`, { params: { operazioneProgressivo } });
  }
  
  esporta(deliberaId: number): Observable<any>{
    return this._http.get(`${this.delibera_api}/esporta-finalizzati/${deliberaId}`, { responseType: 'blob' });
  }

  // --------------- LOG PROTOCOLLO ---------------

  getCheckProgressivoProtocollo(idDelibera: number): Observable<CheckProgressiviDto>{
    return this._http.get<CheckProgressiviDto>(this.log_protocollo_api + `/controllo-progressivo-delibere/${idDelibera}`);
  }

}
